import {colors, translations} from '@/helpers/pixStatus'
import {colors as transferColors, translations as transferTranslations} from '@/helpers/transferStatus'
import orderStatuses from '@/helpers/orderStatuses'

export default function () {
  return {
    page: 1,
    totalPages: 0,
    perPage: 15,
    searchParams: {},
    payables: [],
    apiUrl: process.env.VUE_APP_API_URL,
    colors,
    translations,
    transferColors,
    transferTranslations,
    commissionPercent: null,
    orderStatuses,
    fields: [
      {
        key: 'trip',
        label: 'Pedido'
      },
      {
        key: 'agency',
        label: 'Agência',
      },
      {
        key: 'amount',
        label: 'Valor a repassar'
      },
      {
        key: 'paymentDate',
        label: 'Previsão pagamento'
      },
      {
        key: 'pixMessage',
        label: 'Mensagem pix'
      },
      {
        key: 'pixKey',
        label: 'Chave pix'
      },
      {
        key: 'order.status',
        label: 'Status pedido'
      },
      {
        key: 'status',
        label: 'Status'
      },
      {
        key: 'pix',
        label: 'PIX'
      },
      {
        key: 'transfer',
        label: 'Transferência'
      },
      {
        key: 'paidOn',
        label: 'Enviado em'
      },
    ]
  }
}
